/**
 * @generated SignedSource<<3a3ec1b21d289d04143aea32141f4461>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RecordBwaMonthInput = {
  balances: ReadonlyArray<BwaMonthBalanceInput>;
  figures: BwaFiguresInput;
  month: string;
};
export type BwaFiguresInput = {
  depreciation: number;
  hostingAndLicences: number;
  incomeTaxes: number;
  otherCosts: number;
  otherOperatingIncome: number;
  personnelCosts: number;
  revenue: number;
};
export type BwaMonthBalanceInput = {
  bankAccountIdentifier: string;
  closingBalance: number;
};
export type EditBwaMonthDialogMutation$variables = {
  input: RecordBwaMonthInput;
};
export type EditBwaMonthDialogMutation$data = {
  readonly recordBwaMonth: {
    readonly balances: ReadonlyArray<{
      readonly bankAccountIdentifier: string;
      readonly closingBalance: number;
      readonly computedBalance: number;
      readonly difference: number;
    }>;
    readonly changedAt: any | null | undefined;
    readonly changedBy: string | null | undefined;
    readonly figures: {
      readonly depreciation: number;
      readonly hostingAndLicences: number;
      readonly incomeTaxes: number;
      readonly otherCosts: number;
      readonly otherOperatingIncome: number;
      readonly personnelCosts: number;
      readonly revenue: number;
    };
    readonly id: string;
  };
};
export type EditBwaMonthDialogMutation = {
  response: EditBwaMonthDialogMutation$data;
  variables: EditBwaMonthDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BwaMonth",
    "kind": "LinkedField",
    "name": "recordBwaMonth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BwaFigures",
        "kind": "LinkedField",
        "name": "figures",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherOperatingIncome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personnelCosts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hostingAndLicences",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherCosts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "depreciation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incomeTaxes",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BwaMonthBalance",
        "kind": "LinkedField",
        "name": "balances",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bankAccountIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closingBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "computedBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difference",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBwaMonthDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBwaMonthDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9bbf28454a661372d66d89adc062bed5",
    "id": null,
    "metadata": {},
    "name": "EditBwaMonthDialogMutation",
    "operationKind": "mutation",
    "text": "mutation EditBwaMonthDialogMutation(\n  $input: RecordBwaMonthInput!\n) {\n  recordBwaMonth(input: $input) {\n    id\n    figures {\n      revenue\n      otherOperatingIncome\n      personnelCosts\n      hostingAndLicences\n      otherCosts\n      depreciation\n      incomeTaxes\n    }\n    changedBy\n    changedAt\n    balances {\n      bankAccountIdentifier\n      closingBalance\n      computedBalance\n      difference\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a6a6a49edc3ec011be10472312f7fb4";

export default node;
